<script setup>
import { ref, onMounted, watch, onUnmounted } from "vue";
import { getCheckSum, sendReport, isOGM8K } from "../common/index.js";
import { reqInitData } from "../baseData/system";
import { reportParams, mouseDevice } from "@/common";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { NPopover } from "naive-ui";
import { language } from "@/hooks/util/i18n";
const current = ref(0);
const defaultValue = ref([]);
const main = useStore();
const { device, init, indexData, languageValue, changeSetting } =
  storeToRefs(main);
const reportData =
  "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
//  [
//   "00 00 00 00 00 00 00 00 00 00 0000 00 00 00 0000 00 00 00 00 00 00 00 00 00 0000 00 00 00",
//   "00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 ",
// ];
const list = [
  {
    img: require("@/images/dpi/dpi1.png"),
    imgActive: require("@/images/dpi/dpi-active1.png"),
    color: "#97B6CC",
    value: "125Hz",
    data: "0004 00 82 04 00",
  },
  {
    img: require("@/images/dpi/dpi2.png"),
    imgActive: require("@/images/dpi/dpi-active2.png"),
    color: "#198933",
    value: "250Hz",
    data: "0004 00 82 04 01",
  },
  {
    img: require("@/images/dpi/dpi3.png"),
    imgActive: require("@/images/dpi/dpi-active3.png"),
    color: "#151f81",
    value: "500Hz",
    data: "0004 00 82 04 02",
  },
  {
    img: require("@/images/dpi/dpi4.png"),
    imgActive: require("@/images/dpi/dpi-active4.png"),
    color: "#7b2586",
    value: "1000Hz",
    data: "0004 00 82 04 03",
  },
  {
    img: require("@/images/dpi/dpi5.png"),
    imgActive: require("@/images/dpi/dpi-active5.png"),
    color: "#00ffff",
    value: "2000Hz",
    data: "0004 00 82 04 04",
  },
  {
    img: require("@/images/dpi/dpi6.png"),
    imgActive: require("@/images/dpi/dpi-active6.png"),
    color: "#ffff00",
    value: "4000Hz",
    data: "0004 00 82 04 05",
  },
  {
    img: require("@/images/dpi/dpi7.png"),
    imgActive: require("@/images/dpi/dpi-active7.png"),
    color: "#ffffff",
    value: "8000Hz",
    data: "0004 00 82 04 06",
  },
];
const selectHeight = ref(1);
const systemData = ref("");

// 获取回报率
watch(changeSetting, async (newValue) => {
  if (newValue) {
    const arr = newValue.split(" ");
    const value = parseInt(arr[10], 16);
    if (current.value !== value) {
      current.value = value;
      systemData.value[2] = `0${value}`;
      let { reportId, reportData } = reportParams(
        reqInitData + getCheckSum(reqInitData)
      );
      await device.value.sendReport(reportId, reportData);
    }
  }
});

const sendReportRate = async (idx) => {
  systemData.value[2] = `0${idx}`;
  current.value = idx;
  const before = list[idx].data + reportData;

  let value = before + getCheckSum(before);

  sendReport(value);
};
const changeLODheight = (data) => {
  const num = mouseDevice() === "v2" ? 8 : 0;
  selectHeight.value = data;
  systemData.value[33 - num] = selectHeight.value.toString().padStart(2, "0");

  const str = systemData.value.join("");
  sendReport(str + getCheckSum(str));
};

onMounted(async () => {
  if (device.value) {
    // 读取鼠标的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    await device.value.sendReport(reportId, reportData);
  }
});
onUnmounted(() => {
  main.initData("");
  main.addDpi("");
});

watch(
  indexData,
  (newValue, oldValue) => {
    const arr = newValue.split(" ");
    if (arr[3] === "81") return;
    if (defaultValue.value.length && defaultValue.value === newValue) {
      return;
    }
    if (!newValue) {
      return;
    }

    defaultValue.value = newValue;

    const num = mouseDevice() === "v2" ? 8 : 0;
    systemData.value = [num === 8 ? "00 04 00 a5 02" : "00 04 00 ad 02"].concat(
      arr.slice(5, arr.length - 1)
    );
    defaultValue.value = arr;

    current.value = parseInt(arr[6], 16);
    selectHeight.value = parseInt(arr[37 - num]);

    // console.log("defalut", defaultValue.value);
  },
  { deep: true }
);
</script>

<template>
  <div class="bg">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top">
      <n-popover>
        <template #trigger>
          <img src="@/images/rate-icon1.png" alt="" style="cursor: pointer" />
        </template>
        <span>{{ language[languageValue]["回报率"] }}</span>
      </n-popover>

      <span class="middle">{{ language[languageValue]["回报率"] }}</span>
      <n-popover trigger="hover">
        <template #trigger>
          <img src="@/images/rate-icon2.png" alt="" style="cursor: pointer" />
        </template>
        <span>{{
          language[languageValue]["调整设备向电脑回送报告的频率"]
        }}</span>
      </n-popover>
    </div>
    <div class="linear"></div>
    <div class="content">
      <div class="title" style="margin-bottom: 16px">
        {{ language[languageValue]["固定数值"] }}
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <div
          v-for="(item, index) in list.slice(0, isOGM8K() ? 7 : 4)"
          :key="index"
          @click="sendReportRate(index)"
          class="item"
        >
          <img
            :src="current === index ? item.imgActive : item.img"
            alt=""
            style="width: 30px; height: 85px"
          />
          <div class="numberValue" :class="{ white: current === index }">
            {{ item.value }}
          </div>
          <div :class="{ triangle: current === index }"></div>
        </div>
      </div>
    </div>
    <div class="linear" style="margin-top: 38px"></div>
    <div class="bottom">
      <div style="margin-bottom: 29px">
        <span class="title">{{ language[languageValue]["LOD高度"] }}</span>
        <n-popover trigger="hover">
          <template #trigger>
            <span style="margin-left: 12px" class="title">?</span>
          </template>
          <span>{{
            language[languageValue][
              "鼠标离开桌面停止运动的距离，低：1mm，高：2mm"
            ]
          }}</span>
        </n-popover>
      </div>
      <div
        style="
          width: 22px;
          height: 72px;
          background-color: #255b67;
          margin: 0 auto;
          cursor: pointer;
        "
        @click="changeLODheight(2)"
      >
        <span
          style="position: relative; right: -30px; top: 30px; color: #5b686e"
          :class="{ selectedIcon: selectHeight === 2 }"
          >2.0mm</span
        >
      </div>
      <div
        style="
          width: 22px;
          height: 72px;
          background-color: #216d7d;
          margin: 0 auto;
          cursor: pointer;
        "
        @click="changeLODheight(1)"
      >
        <span
          style="position: relative; right: -30px; top: 30px; color: #5b686e"
          :class="{ selectedIcon: selectHeight === 1 }"
          >1.0mm</span
        >
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.bg {
  color: #fff;

  width: 288px;
  .bottom {
    width: 288px;
    height: 242px;
    background: linear-gradient(
      90deg,
      rgba(19, 52, 71, 0.22),
      rgba(2, 12, 22, 0.22)
    );
    padding: 20px;
    box-sizing: border-box;
    .title {
      font-family: "PingFang";
      font-weight: bold;
      font-size: 14px;
      color: #b5d8f1;
    }
  }
  .numberValue {
    font-family: PingFang;
    font-weight: 500;
    font-size: 14px;
    color: #637077;
    margin-left: -5px;
  }
  .white {
    color: #fff;
  }
  .title {
    font-family: PingFang;
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .content {
    width: 288px;
    padding: 34px;
    padding-bottom: 25px;
    background: linear-gradient(
      90deg,
      rgba(19, 52, 71, 0.22),
      rgba(2, 12, 22, 0.22)
    );
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 16px;

    height: 64px;
    border-bottom-right-radius: 15px;
    padding: 0 18px 0 26px;
    .middle {
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
    }
  }
  .rate {
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    text-align: center;
    background-color: #15211d;
    margin-bottom: 20px;
  }
  .bg_box {
    width: 30px;
    height: 100px;
    margin-right: 30px;
    margin-bottom: 10px;
    &::before {
      background-color: #dd0604;
    }
  }
  .item {
    cursor: pointer;
    padding-bottom: 20px;
    position: relative;

    &:nth-child(-n + 4) {
      margin-right: 25px;
      margin-bottom: 38px;
    }
    &:nth-child(n + 4) {
      margin-right: 17px;
    }
  }
  .triangle {
    position: absolute;
    left: 6px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-bottom-color: #255b67;
  }
  .selectedIcon {
    color: #fff !important;
  }
  .selectedIcon::before {
    position: absolute;
    left: -50px;
    content: "";
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: #fff;
  }
}
</style>
